export default "__VITE_ASSET__Cs0s8txP__"